import { render, staticRenderFns } from "./VaDropdown.demo.vue?vue&type=template&id=6f8e5382&"
import script from "./VaDropdown.demo.vue?vue&type=script&lang=js&"
export * from "./VaDropdown.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports